module.exports = __webpack_public_path__ + "img/arrow.fd2c28d7.gif";